import React, { useState, useEffect } from "react";
import List from "../../styledComponents/Table/List";
import moment from "moment";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import { useHistory } from "react-router-dom";
import "../InsuranceDashboard.css";

export const InsuranceTable = ({ data, deletePost }) => {
  const history = useHistory();

  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const cols_insurance = [
    {
      title: "Policy Name",
      dataIndex: "Nickname",
      key: "Nickname",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Start Date",
      dataIndex: "Policy Start Date",
      key: "Policy Start Date",
      render: (record) =>
        record ? moment(record).format("DD-MM-YYYY") : "N/A",
    },
    {
      title: "Policy End Date",
      dataIndex: "Policy End Date",
      key: "Policy End Date",
      render: (record) =>
        record ? moment(record).format("DD-MM-YYYY") : "N/A",
    },
    {
      title: "Insurance Company",
      dataIndex: "Carrier",
      key: "Carrier",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Number",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Year Premium",
      dataIndex: "year_premium",
      key: "year_premium",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Actions",
      key: "id",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>

                    <li
                      className="liHover"
                      onClick={() => {
                        deletePost(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>

                    <li
                      className="liHover"
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}
                    >
                      Update
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const cols_investments = [
    {
      title: "Insurance Products",
      dataIndex: "module",
      key: "module",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Insured",
      dataIndex: "Insured",
      key: "Insured",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Carrier",
      dataIndex: "carrier",
      key: "carrier",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy #",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "End Date",
      dataIndex: "Policy End Date",
      key: "Policy End Date",
      render: (record) =>
        record ? moment(record).format("DD-MM-YYYY") : "N/A",
    },
    {
      title: "Year Premium",
      dataIndex: "year_premium",
      key: "year_premium",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Cash Value",
      dataIndex: "cash_value",
      key: "cash_value",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Income",
      dataIndex: "Current Monthly Income",
      key: "Current Monthly Income",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Death Benefit",
      dataIndex: "death_benefit",
      key: "death_benefit",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Actions",
      key: "id",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>

                    <li
                      className="liHover"
                      onClick={() => {
                        deletePost(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>

                    <li
                      className="liHover"
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}
                    >
                      Update
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const cols_contact_info = [
    {
      title: "Insurance Products",
      dataIndex: "insurance_products",
      key: "insurance_products",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Agent Name",
      dataIndex: "agent_name",
      key: "agent_name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy #",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (record) => (record ? record : "N/A"),
    },
  ];

  const cols_risk = [
    {
      title: "Insurance Products",
      dataIndex: "module",
      key: "module",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Insured",
      dataIndex: "Insured",
      key: "Insured",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy #",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "End Date",
      dataIndex: "Policy End Date",
      key: "Policy End Date",
      render: (record) =>
        record ? moment(record).format("DD-MM-YYYY") : "N/A",
    },
    {
      title: "Deductible",
      dataIndex: "Deductible",
      key: "Deductible",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Year Premium",
      dataIndex: "Year_premium",
      key: "Year_premium",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Liability Coverage",
      dataIndex: "liability_coverage",
      key: "liability_coverage",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Actions",
      key: "id",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>

                    <li
                      className="liHover"
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      onClick={() => {
                        deletePost(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };

  const fnEdit = (record) => {
    history.push(`/insurance_new/attributes/${record.module}/${record.id}`);
  };
  const fnView = (record) => {
    history.push(
      `/insurance_new/attributes/${record.module}/${record.id}/view`
    );
  };

  return (
    <React.Fragment>
      <div className="insuranceInfoMaincard">
        <h3 className="liablitycardheading">Insurance Policies</h3>
        <List cols={cols_insurance} rows={data} />
      </div>

      {/* <div className="insuranceInfoMaincard">
        <h3 className="liablitycardheading">
          Insurance Policies as Investment{" "}
          <span className="insurance-table-sub-headings">
            / Annuity, Final Expense, Guaranted Issue, Long Term Care Hybrid,
            Universal Life, Variables, Whole Life
          </span>
        </h3>
        <List cols={cols_investments} rows={creditRows} />
      </div> */}
      {/* <div className="insuranceInfoMaincard">
        <h3 className="liablitycardheading">
          Insurance Policies - Risk Only{" "}
          <span className="insurance-table-sub-headings">
            / Automobile, Long Term Disability ,Term ,Umbrella ,Home Owners,
            Fire,Flood, Earthquake
          </span>
        </h3>
        <List cols={cols_risk} rows={liabilitiesCredit} />
      </div>
      <div className="insuranceInfoMaincard">
        <h3 className="liablitycardheading">
          Insurance Contact Info
        </h3>
        <List cols={cols_contact_info} rows={[]} />
      </div> */}
    </React.Fragment>
  );
};
